/* Disciple Project — product-page spin (Shopify version of the prototype's assets/product.js).
   Needs dsp-core.js loaded first. Works on every .dsp-spin section on the page, each on its own.
   Big drag-to-turn view: drag, left/right arrow keys (Shift = 45°), Front / Side / Back buttons, degree readout.
   The prototype's demo "Notify me" form is NOT here on purpose (a real sign-up is a separate, gated step).

   What the section gives this script (rendered by sections/dsp-spin.liquid):
     root .dsp-spin  data-frames-base="…"  data-frames="brown-jeans"  data-rest="70" */
(() => {
  if (window.DSPSpin) return;
  const { Turntable, preloadFrames, bindLoader, norm, DEFAULT_REST, registerSections } = window.DSPCore;

  function createSpin(root) {
    let dead = false, tt = null, raf = 0, arrival = 0;
    const base = root.dataset.framesBase || '';
    const prefix = root.dataset.frames;
    const rest = Number(root.dataset.rest) || DEFAULT_REST;
    const cv = root.querySelector('.dsp-pdp-cv');
    const deg = root.querySelector('.dsp-deg');
    const views = [...root.querySelectorAll('.dsp-view')];
    if (!prefix || !cv) return { destroy() {} };

    function markView(angle) {
      for (const v of views) v.setAttribute('aria-pressed', String(Number(v.dataset.angle) === angle));
    }
    const resize = () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => { if (tt) tt.resize(); }); };

    const loader = bindLoader(root.querySelector('.dsp-loader'), 'Loading the piece');
    preloadFrames(base, prefix, 'full', loader.progress).then(frames => {
      if (dead) return;
      tt = new Turntable(cv, frames, t => {
        deg.textContent = `${String(t.frameAngle).padStart(3, '0')}°`;
        markView(t.frameAngle);
      });
      tt.attachDrag(cv);
      // arrival: the piece starts as it hangs on the rail and turns to face you
      tt.set(rest);
      root.classList.add('is-ready');
      arrival = requestAnimationFrame(() => tt.tweenTo(0, 900));

      for (const v of views) v.addEventListener('click', () => tt.tweenTo(Number(v.dataset.angle), 600));
      cv.addEventListener('keydown', e => {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        tt.nudge((e.key === 'ArrowLeft' ? -1 : 1) * (e.shiftKey ? 45 : 5));
      });
      window.addEventListener('resize', resize);
      // keep the angle bounded after long spins
      cv.addEventListener('pointerup', () => setTimeout(() => { if (tt && !tt.raf) tt.angle = norm(tt.angle); }, 0));
    }).catch(err => {
      if (dead) return;
      loader.fail();
      console.warn(err);
    });

    return {
      destroy() {
        dead = true;
        cancelAnimationFrame(raf);
        cancelAnimationFrame(arrival);
        if (tt) tt.stop();
        window.removeEventListener('resize', resize);
      },
    };
  }

  window.DSPSpin = registerSections('.dsp-spin', createSpin);
})();
